<div class="chart-infoBar" #infoBar></div>
<div #chart></div>
